const linkCls = "gfxl117dwgj";
const buttonCls = "gfxb1trfehh";
const expandableCls = "gfxe19pni34";
const expandableIconCls = "gfxebcvrz9";
const tooltip = "gfxtp5e4p7";
const tooltipArrow = "gfxt1f19g98";

export { buttonCls, expandableCls, expandableIconCls, linkCls, tooltip, tooltipArrow };
import "./LinkWrapper.linaria.module.css";
//# sourceMappingURL=LinkWrapper.js.map
